// src/firebase/firebase.js
import {initializeApp} from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyB5xGBjCjIrcGEaBNd6vbUXPdAVJusg3d8",
    authDomain: "notification-system-10a99.firebaseapp.com",
    projectId: "notification-system-10a99",
    storageBucket: "notification-system-10a99.firebasestorage.app",
    messagingSenderId: "723227636576",
    appId: "1:723227636576:web:42ddb60dc58531e203a405",
};

const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;
